import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Items = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(10)};

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        justify-content: space-between;
        gap: ${rem(10)};
    }

    @media (min-width: ${breakpoints.lg}px) {
        margin: ${rem(20)} 0;
    }
`;

export const Item = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(12)};
    padding: ${rem(35)};

    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.md}px) {
        width: 30%;
    }

    svg {
        width: ${rem(50)};
        height: ${rem(50)};
        margin-bottom: ${rem(20)};
    }
`;

export const Question = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};

    span {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const Answer = styled.span`
    padding-top: ${rem(20)};
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};
    margin-top: auto;
    color: ${({ theme }) => theme.colors.grey};

    .mail {
        color: ${({ theme }) => theme.colors.primary};
    }

    .phone {
        color: ${({ theme }) => theme.colors.primary};
    }
`;
